jQuery( function( $ ) {
	//SHARE FUNCTIONS FOR TOP SHAREBUTTON ON SINGLE-RECIPE
	$( '.share-recipe-button' ).on( 'click', function( e ) {
		e.preventDefault();
		$( '.share-recipe-button' ).css( 'visibility', 'hidden' );
		$( '.share-recipe' ).toggleClass( 'share' );
		$( '.social-icons-column' ).css( 'display', 'flex' );
		$( '.share-close-button' ).show();
		$( '.site-overlay' ).addClass( 'visible' );
	} );

	$( '.share-close-button' ).on( 'click', function( e ) {
		e.preventDefault();
		$( '.share-recipe-button' ).css( 'visibility', 'visible' );
		$( this ).hide();
		$( '.social-icons-column' ).css( 'display', 'none' );
		$( '.share-recipe' ).toggleClass( 'share' );
		$( '.site-overlay' ).removeClass( 'visible' );
	} );

	//SHARE FUNCTIONS FOR SECOND/BOTTOM SHAREBUTTON ON SINGLE-RECIPE
	$( '.share-recipe-button-bottom' ).on( 'click', function( e ) {
		e.preventDefault();
		$( this ).hide();
		$( '.share-recipe-bottom' ).toggleClass( 'share' );
		$( '.social-icons-column-bottom' ).css( 'display', 'flex' );
		$( '.share-close-button-bottom' ).show();
		$( '.site-overlay' ).addClass( 'visible' );
	} );

	$( '.share-close-button-bottom' ).on( 'click', function( e ) {
		e.preventDefault();
		$( this ).hide();
		$( '.share-recipe-button-bottom' ).show();
		$( '.social-icons-column-bottom' ).css( 'display', 'none' );
		$( '.share-recipe-bottom' ).toggleClass( 'share' );
		$( '.site-overlay' ).removeClass( 'visible' );
	} );

	//SHARE FUNCTIONS FOR RECIPE-ARCHIVE
	$( '.square-share-button' ).on( 'click', function( e ) {
		e.preventDefault();
		$( this ).siblings( '.square-share-box' ).show();
		$( this, '.square-share-button' ).css( 'opacity', '0' );
	} );
	$( '.square-share-close-button' ).on( 'click', function( e ) {
		e.preventDefault();
		$( this ).closest( '.square-share-box' ).hide();
		$( '.square-share-button' ).css( 'opacity', '1' );
	} );
} );
